const prefix = '@@KANDY/SUBSCRIPTION/'

export const SUBSCRIBE = prefix + 'SUBSCRIBE'
export const SUBSCRIBE_FINISHED = prefix + 'SUBSCRIBE_FINISHED'

export const UNSUBSCRIBE = prefix + 'UNSUBSCRIBE'
export const UNSUBSCRIBE_FINISHED = prefix + 'UNSUBSCRIBE_FINISHED'

export const RESUBSCRIPTION_FINISHED = prefix + 'RESUBSCRIPTION_FINISHED'

export const REGISTER_SUB_SERVICE = prefix + 'REGISTER_SUB_SERVICE'
export const PLUGIN_SUBSCRIPTION = prefix + 'PLUGIN_SUBSCRIPTION'
export const PLUGIN_SUBSCRIPTION_FINISHED = prefix + 'PLUGIN_SUBSCRIPTION_FINISHED'
export const PLUGIN_UNSUBSCRIPTION = prefix + 'PLUGIN_UNSUBSCRIPTION'
export const PLUGIN_UNSUBSCRIPTION_FINISHED = prefix + 'PLUGIN_UNSUBSCRIPTION_FINISHED'

export const CHANNEL_OPENED = prefix + 'CHANNEL_OPENED'
export const CHANNEL_CLOSED = prefix + 'CHANNEL_CLOSED'
